import { render } from "./FlowDetails.vue?vue&type=template&id=6b533420"
import script from "./FlowDetails.vue?vue&type=script&lang=js"
export * from "./FlowDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__